export default __webpack_public_path__ + "static/media/bgAbout.97164a92.svg";